import { useUser } from '@/app/providers';
import { hasFeature } from '@/domain/authentication';
import { FieldSalesRepresentativeModifySection } from './FieldSalesRepresentativeModifySection';
import { FieldSalesRepresentativeReadOnlySection } from './FieldSalesRepresentativeReadOnlySection';

interface FieldSalesRepresentativeSectionProps {
  companyId?: string;
}

/**
 * @component FieldSalesRepresentativeSection
 * @description Chooses the read-only own-company state or the editable subcompany state for field sales representatives.
 *
 * @props
 *   companyId (string, optional) - Company currently edited in the master-data form.
 *
 * @changelog
 *   2026-07-08 - Initial creation.
 */
export function FieldSalesRepresentativeSection({
  companyId,
}: FieldSalesRepresentativeSectionProps) {
  const { user } = useUser();
  const activeCompanyId = user?.companyUuid;
  const canModify = Boolean(
    user && hasFeature(user, 'fieldSalesRepresentative.modify')
  );

  if (!companyId || !activeCompanyId) {
    return null;
  }

  if (companyId === activeCompanyId) {
    return <FieldSalesRepresentativeReadOnlySection companyId={companyId} />;
  }

  if (!canModify) {
    return null;
  }

  return (
    <FieldSalesRepresentativeModifySection
      companyId={activeCompanyId}
      customerCompanyId={companyId}
      companyName={user?.companyName}
    />
  );
}
